import React from "react";
import { BrowserRouter, HashRouter, Switch } from "react-router-dom";
import { PTSMasterScreen_ScreenProvider } from "../screens/ptsmasterscreen/ptsmasterscreen-context";
import { ForgotPassword_Screen } from "../screens/forgotpassword/forgotpassword";
import { PTSMasterScreen_Screen } from "../screens/ptsmasterscreen/ptsmasterscreen";
import { UserList_Screen } from "../screens/userlist/userlist";
import { Profile_Screen } from "../screens/profile/profile";
import { LeftMenu_Screen } from "../screens/leftmenu/leftmenu";
import { ProjelerListesi_Screen } from "../screens/projelerlistesi/projelerlistesi";
import { TarimsalSulamaOnSurecler_Screen } from "../screens/tarimsalsulamaonsurecler/tarimsalsulamaonsurecler";
import { TitleEdit_Screen } from "../screens/titleedit/titleedit";
import { ChangePassword_Screen } from "../screens/changepassword/changepassword";
import { UserEdit_Screen } from "../screens/useredit/useredit";
import { CatiGesOnSurecler_Screen } from "../screens/catigesonsurecler/catigesonsurecler";
import { UserView_Screen } from "../screens/userview/userview";
import { CatiGES_Screen } from "../screens/catiges/catiges";
import { Projeler_Screen } from "../screens/projeler/projeler";
import { ProjeDetay_Screen } from "../screens/projedetay/projedetay";
import { Signin_Screen } from "../screens/signin/signin";
import { HomePage_Screen } from "../screens/homepage/homepage";
import { BildirimListesi_Screen } from "../screens/bildirimlistesi/bildirimlistesi";
import { ProjeEdit_Screen } from "../screens/projeedit/projeedit";
import { ResetPassword_Screen } from "../screens/resetpassword/resetpassword";
import { VerificationCode_Screen } from "../screens/verificationcode/verificationcode";
import { UserAdd_Screen } from "../screens/useradd/useradd";
import { Projelercopy_Screen } from "../screens/projelercopy/projelercopy";
import { Signup_Screen } from "../screens/signup/signup";
import { YeniProjeGenel_Screen } from "../screens/yeniprojegenel/yeniprojegenel";
import { RoleList_Screen } from "../screens/rolelist/rolelist";



import LocalStorageService from "../auth/local-storage-service";
import { Redirect } from "../auth/redirect";
import { IAppMode, IAuthType } from "../bootstrapper";
import { NoMatch404 } from "../components/common/no-match-404";
import { Dashboard, ForgotPassword, Login, ResetPassword } from "../components/default_screens/index";
import { KuikaInfo } from "../components/default_screens/kuika-info";
import { MfeLogin } from "../components/mfe/mfe-login";
import { MsalLogin } from "../components/msal/msal-login";
import { MsalRedirect } from "../components/msal/msal-redirect";
import { NotificationRedirect } from "../components/notification/notification-redirect";
import { ScanCompareTest } from "../screens/scan-compare-test";
import { WFMailInteraction } from "../screens/wf-mail-interaction";
import confJson from "../shared/json/conf.json";
import { KMainFunctions } from "../shared/utilty/main-functions";
import { MasterScreenWrapper } from "./master-screen-wrapper";
import { PrivateRoute } from "./private-route";
import { Route } from "./route";

class PTSMasterScreen_Screen_Wrapper extends MasterScreenWrapper {
  protected get anonymousPaths(): string[] { return []; }
  protected get MasterComponent(): React.ComponentType<any> { return PTSMasterScreen_Screen; }
  protected get MasterProvider(): React.ComponentType<any> { return PTSMasterScreen_ScreenProvider; }
  protected renderSwitchWrapper(): React.ReactNode {
    return (
      <Switch>
        <PrivateRoute exact path="/" component={HomePage_Screen} />
        <PrivateRoute exact path="/userlist" component={UserList_Screen} />
        <PrivateRoute exact path="/projelerlistesi" component={ProjelerListesi_Screen} />
        <PrivateRoute exact path="/catiges" component={CatiGES_Screen} />
        <PrivateRoute exact path="/projeler" component={Projeler_Screen} />
        <PrivateRoute exact path="/homepage" component={HomePage_Screen} />
        <PrivateRoute exact path="/bildirimlistesi" component={BildirimListesi_Screen} />
        <PrivateRoute exact path="/projelercopy" component={Projelercopy_Screen} />
      </Switch>
    );
  }
}



export interface IRouterState {}

export type IRouterType = "HashRouter" | "BrowserRouter";

export interface IRouterProps {
  authType: IAuthType;
  routerType?: IRouterType;
  external_access_token?: string;
  external_refresh_token?: string;
  external_user?: string;
  startingScreen?: string;
  appMode?: IAppMode;
  // Allow only screenInput_* props with specific typing
  [key: `screenInput_${string}`]: unknown;
}

declare let window: any;
export class Router extends React.Component<IRouterProps, IRouterState> {
  timerId: any = null;

  private hasNavigatedToStartingScreen: boolean = false;

  componentDidMount = () => {
    // SET LANGUAGE TO HTML BODY
    const lang = LocalStorageService.getUserLanguage();
    if (lang) {
      const fixedLangAttributeValue = lang.replace("_", "-");
      document.body.setAttribute("lang", fixedLangAttributeValue);
    }
    // Handle starting screen navigation for web component apps (only once)
    if (this.props.appMode === "WebComponent" && this.props.startingScreen && !this.hasNavigatedToStartingScreen) {
      this.hasNavigatedToStartingScreen = true;
      this.navigateToStartingScreen();
    }

    window.onfocus = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = true;
    };

    window.onblur = function () {
      if (window.kuika === undefined) {
        window.kuika = {};
      }
      window.kuika.isTabActive = false;
    };

    if (!window.styler_speed) {
      window.styler_speed = 20;
    } else if (window.styler_speed < 500) {
      window.styler_speed += 100;
    }

    if (window?.kuika?.activeKuikaComponent !== undefined) {
      return;
    }
    const runTimeout = () => {
      this.timerId = setTimeout(() => {
        const allFormItems: NodeListOf<HTMLElement> = document.querySelectorAll(".kFormItem");
        if (allFormItems) {
          allFormItems.forEach((formItem) => {
            if (formItem.getAttribute("data-display-affected") === "true") {
              return;
            }
            const antFormItemControlInputContent: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input .ant-form-item-control-input-content"
            );
            const antFormItemControlInput: HTMLElement = formItem.querySelector(
              ".ant-form-item-control .ant-form-item-control-input"
            );
            const antFormItemControl: HTMLElement = formItem.querySelector(".ant-form-item-control");

            if (
              antFormItemControlInputContent &&
              antFormItemControlInputContent.children &&
              antFormItemControlInputContent.children.length > 0
            ) {
              const formChild: HTMLElement = antFormItemControlInputContent.children[0] as HTMLElement;
              let calculatedDisplay: string = formChild.style.display;
              if (
                calculatedDisplay &&
                antFormItemControl &&
                antFormItemControlInput &&
                antFormItemControlInputContent
              ) {
                if (calculatedDisplay === "inline-flex" || calculatedDisplay === "inline-block") {
                  calculatedDisplay = "";
                  formItem.style.width = formChild.style.width ?? "auto";
                  formItem.style.display = "inline-block";
                  formItem.setAttribute("data-display-affected", "true");
                }
              }
            }
          });
        }
        this.componentDidMount();
      }, window.styler_speed);
    };

    runTimeout();

    setTimeout(() => {
      clearTimeout(this.timerId);
    }, 10000);
  };

  private getScreenInputPropKeys = (): string[] => {
    return Object.keys(this.props || {}).filter((k) => k && k.startsWith("screenInput_"));
  };

  private buildScreenInputsFromProps = (): Record<string, unknown> => {
    const screenInputs: Record<string, unknown> = {};
    this.getScreenInputPropKeys().forEach((key) => {
      const inputName = key.substring("screenInput_".length);
      screenInputs[inputName] = this.props[key];
    });
    return screenInputs;
  };

  private navigateToStartingScreen = () => {
    try {
      const screenName = this.props.startingScreen as string;
      const baseHash = screenName.startsWith("#") ? screenName : `#${screenName}`;
      const inputs = this.buildScreenInputsFromProps();
      const params = new URLSearchParams();

      Object.keys(inputs).forEach((k) => {
        const v = inputs[k];
        if (v !== undefined && v !== null) {
          params.append(k, typeof v === "string" ? v : JSON.stringify(v));
        }
      });

      const qs = params.toString();
      const hash = `${baseHash}${qs ? `?${qs}` : ""}`;

      if (window.location.hash !== hash) {
        window.location.hash = hash;
      }
    } catch (e) {
      console.error("Error navigating to starting screen:", e);
    }
  };

  render() {
    const KuikaRouter = this.KuikaRouter();
    return (
      <>
        <KuikaRouter>
          <Switch key="Switch">
            
                        <Route exact path="/" component={PTSMasterScreen_Screen_Wrapper} />
            <Route path={["/userlist", "/projelerlistesi", "/catiges", "/projeler", "/homepage", "/bildirimlistesi", "/projelercopy"]} component={PTSMasterScreen_Screen_Wrapper} />
            <Route exact path="/forgotpassword" component={ForgotPassword_Screen} />
            <PrivateRoute exact path="/profile" component={Profile_Screen} />
            <PrivateRoute exact path="/leftmenu" component={LeftMenu_Screen} />
            <PrivateRoute exact path="/tarimsalsulamaonsurecler" component={TarimsalSulamaOnSurecler_Screen} />
            <PrivateRoute exact path="/titleedit" component={TitleEdit_Screen} />
            <PrivateRoute exact path="/changepassword" component={ChangePassword_Screen} />
            <PrivateRoute exact path="/useredit" component={UserEdit_Screen} />
            <PrivateRoute exact path="/catigesonsurecler" component={CatiGesOnSurecler_Screen} />
            <PrivateRoute exact path="/userview" component={UserView_Screen} />
            <PrivateRoute exact path="/projedetay" component={ProjeDetay_Screen} />
            <Route exact path="/signin" component={this.LoginComponent()} />
            <PrivateRoute exact path="/projeedit" component={ProjeEdit_Screen} />
            <Route exact path="/resetpassword" component={ResetPassword_Screen} />
            <Route exact path="/verificationcode" component={VerificationCode_Screen} />
            <PrivateRoute exact path="/useradd" component={UserAdd_Screen} />
            <Route exact path="/signup" component={Signup_Screen} />
            <PrivateRoute exact path="/yeniprojegenel" component={YeniProjeGenel_Screen} />
            <PrivateRoute exact path="/rolelist" component={RoleList_Screen} />

            <Route path="/redirect" component={Redirect} />
            <Route path={"/login"} component={this.LoginComponent()} />
            
            
            <Route exact path="/forgotpassword" component={ForgotPassword} />
            <Route exact path="/resetpassword" component={ResetPassword} />
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <Route exact path="/kuikainfo" component={KuikaInfo} />
            <Route exact path="/msalredirect" component={MsalRedirect} />
            <Route exact path="/wfmailinteraction" component={WFMailInteraction} />
            <PrivateRoute exact path="/scancomparetest" component={ScanCompareTest} />
            <Route exact path="/notificationredirect" component={NotificationRedirect} />
            <Route exact path="/logout" component={Redirect} />
            <Route path="*" component={NoMatch404} />
          </Switch>
        </KuikaRouter>
      </>
    );
  }

  KuikaRouter = () => {
    // Web component case
    let isWebComponentApp: any;
    isWebComponentApp = this.props.appMode === "WebComponent";
    if (
      confJson?.domainName !== undefined &&
      confJson?.applicationName !== undefined &&
      confJson?.applicationName !== "" &&
      window.kuika !== undefined &&
      window.kuika?.apps !== undefined &&
      window.kuika?.apps.length !== undefined &&
      window.kuika?.apps.length > 0
    ) {
      window.kuika?.apps.forEach((app: any) => {
        if (app.appName === confJson.applicationName && app.workspace === confJson.domainName) {
          isWebComponentApp = true;
        }
      });
    }
    if (window.kuika === undefined) {
      window.kuika = {};
    }
    window.kuika.isWebComponentApp = isWebComponentApp;

    if (isWebComponentApp === true || this.props.routerType === "HashRouter") {
      return (props: any) => {
        return <HashRouter key="HashRouter">{props.children}</HashRouter>;
      };
    }
    return (props: any) => {
      if (KMainFunctions.virtualDirectoryURL === "auto" || window?.location?.protocol === "file:") {
        return <BrowserRouter key="BrowserRouter">{props.children}</BrowserRouter>;
      }
      return (
        <BrowserRouter basename={KMainFunctions.virtualDirectoryURL} key="BrowserRouter">
          {props.children}
        </BrowserRouter>
      );
    };
  };

  LoginComponent = () => {
    if (this.props.authType === "MSAL") {
      return MsalLogin;
    }

    const { external_access_token } = this.props;
    const { external_refresh_token } = this.props;
    const { external_user } = this.props;
    // The host injects external_access_token as a short-lived MFE handoff JWT.
    // No refresh_token is involved — the microapp's own backend mints its
    // session cookies once the token is redeemed.
    if (external_access_token !== null && external_access_token !== undefined && external_access_token !== "") {
      return (props: any) => {
        return (
          <MfeLogin
            external_user={external_user}
            external_access_token={external_access_token}
            external_refresh_token={external_refresh_token}
          ></MfeLogin>
        );
      };
    }

    if (this.props.authType === "Kuika") {
      return Signin_Screen;
    }
    return <></>;
  };
}
